/* Florescer — Logo em vídeo.
   Reproduz o vídeo no lugar da logo e, ao terminar, volta à imagem estática.
   Sem JavaScript, sem vídeo ou em qualquer falha: a logo estática permanece. */
(() => {
  const CHAVE = 'fl-logo-video:v1';

  const reduzMovimento = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const noEditor = () =>
    !!(window.Shopify && window.Shopify.designMode);

  const jaVisto = (frequencia) => {
    try {
      if (frequencia === 'navegador') return localStorage.getItem(CHAVE) === '1';
      if (frequencia === 'sessao') return sessionStorage.getItem(CHAVE) === '1';
    } catch (e) {
      /* armazenamento indisponível: trata como nunca visto */
    }
    return false;
  };

  const marcarVisto = (frequencia) => {
    try {
      if (frequencia === 'navegador') localStorage.setItem(CHAVE, '1');
      else if (frequencia === 'sessao') sessionStorage.setItem(CHAVE, '1');
    } catch (e) {
      /* silencioso */
    }
  };

  const init = () => {
    document.querySelectorAll('[data-fl-logo-video]').forEach((el) => {
      if (el.dataset.flLogoVideoReady) return;
      el.dataset.flLogoVideoReady = '1';

      const video = el.querySelector('video');
      if (!video) return;

      const frequencia = el.dataset.frequencia || 'sessao';
      const sempreNoEditor = el.dataset.editor !== 'false';
      const deveTocar =
        (noEditor() && sempreNoEditor) ||
        (!reduzMovimento() && !jaVisto(frequencia));

      if (!deveTocar) return; /* fica estático */

      let marcado = false;
      const encerrar = () => {
        el.classList.remove('is-playing');
        if (!marcado) {
          marcado = true;
          marcarVisto(frequencia);
        }
      };

      video.addEventListener('ended', encerrar);
      video.addEventListener(
        'error',
        () => el.classList.remove('is-playing'),
        true
      );

      const tocar = () => {
        el.classList.add('is-playing');
        if (!marcado) {
          marcado = true;
          marcarVisto(frequencia); /* começa a tocar: já conta como visto */
        }
        const promessa = video.play();
        if (promessa && typeof promessa.catch === 'function') {
          promessa.catch(() => el.classList.remove('is-playing'));
        }
      };

      if (video.readyState >= 2) {
        tocar();
      } else {
        video.addEventListener('loadeddata', tocar, { once: true });
      }

      /* Segurança: se o vídeo não carregar, permanece a logo estática. */
      setTimeout(() => {
        if (el.classList.contains('is-playing') && video.paused && video.readyState < 2) {
          el.classList.remove('is-playing');
        }
      }, 4000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
